import * as yup from "yup";

const validations = yup.object().shape({
  firstName: yup.string().required("Ad alanı zorunludur"),
  lastName: yup.string().required("Soyad alanı zorunludur"),
  departmentId: yup
    .number()
    .min(1, "Departman alanı zorunludur"),
  email: yup
    .string()
    .required("Email alanı zorunludur")
    .email("Geçerli bir email adresi giriniz"),
});
export default validations;
